import { render, staticRenderFns } from "./AlertModification.vue?vue&type=template&id=1f38736c&scoped=true&"
import script from "./AlertModification.vue?vue&type=script&lang=js&"
export * from "./AlertModification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38736c",
  null
  
)

export default component.exports